<template>
  <div class="shop">
    <section class="phoneAll" ref="imageTofile" id="imageTofile">
      <!-- 导航 -->
      <!-- <headerTop class="containwe-padding" :name="pageSetup" /> -->
      <!-- 收藏组件 -->
      <div class="collect" v-if="orgid">
        <collect></collect>
      </div>
      <!-- 动态组件 -->
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <section
          class="phone-container"
          :style="{
            'background-color': pageSetup.bgColor,
            backgroundImage: 'url(' + pageSetup.bgImg + ')'
          }"
        >
          <div v-for="(item, index) in pageComponents" :key="index">
            <keep-alive :include="item.component">
              <component
                :key="index"
                :is="item.component"
                :datas="item.setStyle"
                class="componentsClass"
                :data-type="item.type"
                @clickBanner="clickBanner"
              />
            </keep-alive>
          </div>
        </section>
      </van-pull-refresh>
    </section>
    <tabbar></tabbar>
  </div>

</template>

<script>
import Vue from 'vue';
import { PullRefresh } from 'vant';
Vue.use(PullRefresh);
// 样式初始化
import '@/assets/as/reset.css'
import '@/assets/as/minx.less'

import { decorationShow } from '@/api/shop'
import { mapActions, mapGetters } from 'vuex'


import headerTop from '@/asComponents/headerTop'
import collect from '@/asComponents/collect'
import tabbar from '@/asComponents/tabbar/'

import {
  captiontext,
  placementarea,
  pictureads,
  graphicnavigation,
  richtext,
  magiccube,
  auxiliarysegmentation,
  commoditysearch,
  storeinformation,
  entertheshop,
  notice,
  videoss,
  custommodule,
  communitypowder,
  storenotecard,
  crowdoperation,
  personalizedrecommendation,
  onlineservice,
  listswitching,
  investigate,
  tabBar,
  follow,
  suspension
} from '@/asComponents/componentscom'
export default {
  name: 'shop',
  data() {
    return {
      url: window.location.href,
      isLoading: false,
      orgid: false,
      pageComponents: [],
      pageSetup: {
        // 页面设置属性
        name: '页面标题', //页面名称
        details: '', //页面描述
        isPerson: false, // 是否显示个人中心
        isBack: true, // 是否返回按钮
        titleHeight: 35, // 高度
        bgColor: 'rgba(249, 249, 249, 10)', //背景颜色
        bgImg: '' // 背景图片
      },
      tota: null,
      active: 0,
    }
  },
  activated() {
    //不能使用其他方式设置滚动条高度，否则回导致下拉刷新失效
    // setTimeout(() => {
    //   window.scroll(0, this.$store.state.scroll)
    // }, 500)
  },
  
  async created() {
    // 是否是iframe使用
    if (this.$route.query.type === 'iframe') {
      window.addEventListener('message', e => {
        console.log(e.data, '-------------message')
        let datas = e.data
        this.pageComponents = JSON.parse(datas.component)
        this.pageSetup = JSON.parse(datas.templateJson)
      })
      return
    } else {
      // if (this.$route.query.cid) {
      //   localStorage.setItem('cid',this.$route.query.cid)
      // } else {
      //   if (localStorage.getItem('cid')) {
          
      //   }
      // }
      // this.cid = this.$route.query.cid || localStorage.getItem('cid')
      // this.getOpenUserInfo()
      this.getPageData()
    }

    // await this.loadShopData()
    // let miniprogram = window.localStorage.getItem('miniprogram')
    // console.log(miniprogram, '-------------------miniprogram')

    
  },
  mounted() {},
  methods: {
    ...mapActions(['Login']),
    getOpenUserInfo () {
        let that = this;
        that.Login(that.cid).then((res) => {
            if (!res.data.token) {
                let redirectUrl = '/auth/officialAccount?cid='+that.cid+'&check_code=591060&module=officialAccount&target=' + encodeURIComponent(that.url);
                that.$redirectAuth(redirectUrl);
            }
            this.getPageData()
        }).catch(res => {
            let redirectUrl = '/auth/officialAccount?cid='+that.cid+'&check_code=591060&module=officialAccount&target=' + encodeURIComponent(that.url);
            that.$redirectAuth(redirectUrl);
        })
    },
    getPageData () {
      this.tota = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner',
        overlay: true
      })
      decorationShow().then(res => {
        this.isLoading = false
        if (res.data.store_decoration) {
          let data = JSON.parse(res.data.store_decoration)
          this.pageSetup = data.templateJson
          this.pageComponents = data.component
        }
        this.tota.clear()
      })
    },
    onRefresh() {
      this.getPageData()
    },

    async loadShopData() {
      try {
        // if (this.$route.query.orgId) {
        //   localStorage.setItem('shopTemplateId', this.$route.query.orgId)
        // }

        this.tota = this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner',
          overlay: true
        })
        this.orgid = false
        //  模板数据替换 shopTemplateData.data.shopTemplate 此处可替换成接口
        let shopTemplateData = {
          code: 0,
          success: true,
          error: false /*  */,
          data: {
            shopTemplate: {
"id": null,
"name": "页面标题",
"templateJson": '{"name":"页面标题","details":"","isPerson":false,"isBack":true,"titleHeight":35,"bgColor":"rgba(249, 249, 249, 10)","bgImg":""}',
"component": '[{"component":"listswitching","text":"商品","type":"2-1","active":true,"style":"listswitchingstyle","setStyle":{"text":"商品","commodityType":4,"moditystyle":0,"borderRadius":0,"pageMargin":15,"commodityMargin":10,"textWeight":400,"positions":"left","priceofcommodity":true,"purchasebutton":true,"commoditycorner":true,"purchasebuttonType":0,"commoditycornertype":0,"commodityTagColor":"#ff8c00","tagPosition":0,"imageList":[{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1211/1676347896589063eb09f88fcf5.jpg","id":10,"introduce":"新上架/准新车/0次过户/原厂质保"},{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1137/1676345836016263eb01ec03f5a.jpg","id":9,"introduce":"新上架/准新车/0次过户/原厂质保"},{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1137/1676345836016263eb01ec03f5a.jpg","id":8,"introduce":"新上架/准新车/0次过户/原厂质保"}],"purchase":"马上抢","commoditylisttype":0,"commoditylisttypetab":[{"text":"分组","imageList":[{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1211/1676347896589063eb09f88fcf5.jpg","id":10,"introduce":"新上架/准新车/0次过户/原厂质保"},{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1137/1676345836016263eb01ec03f5a.jpg","id":9,"introduce":"新上架/准新车/0次过户/原厂质保"},{"name":"宝马M4 2021款 M4双门轿跑车 M xDrive 雷霆版","price":"965000.00","coverUrl":"https://lingyuntongtest.oss-cn-guangzhou.aliyuncs.com/2023/0214/1137/1676345836016263eb01ec03f5a.jpg","id":8,"introduce":"新上架/准新车/0次过户/原厂质保"}]},{"text":"分组","imageList":[]}],"tabColor":"#f39800","showMore":false,"moreUrl":null,"bgImg":""}}]',
}


          },
          msg: '成功'
        }
        console.log(shopTemplateData, '----------shopTemplateData')
        if (shopTemplateData.code !== 0) {
          return this.$toast(shopTemplateData.msg)
        }
        let datas = shopTemplateData.data.shopTemplate
        if (!datas) return this.tota.clear()
        this.pageComponents = JSON.parse(datas.component)
        this.pageSetup = JSON.parse(datas.templateJson)
      } catch (error) {
        console.error(error, '--------------loadShopData error')
      } finally {
        this.tota.clear()
      }
    },

    clickBanner() {
      console.log('clickBanner')
    },

    goRouter (e) {
      console.log(e)
    }
  },

  components: {
    collect,
    headerTop,
    captiontext,
    placementarea,
    pictureads,
    graphicnavigation,
    richtext,
    magiccube,
    auxiliarysegmentation,
    commoditysearch,
    storeinformation,
    entertheshop,
    notice,
    videoss,
    custommodule,
    communitypowder,
    storenotecard,
    crowdoperation,
    personalizedrecommendation,
    onlineservice,
    listswitching,
    investigate,
    tabBar,
    follow,
    suspension,
    tabbar
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/as/minx.less';
.shop {
  padding-bottom: 50px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);//兼容 IOS<11.2
  padding-bottom: calc(env(safe-area-inset-bottom) + 50px);//兼容 IOS>11.2

  .phoneAll {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .collect {
    position: absolute;
    top: 28px;
    right: 8px;
    z-index: 1000;
  }
  .phone-container {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  /deep/.van-pull-refresh {
    width: 100%;
  }
  
}
</style>
